import React from "react";
import { SectionCTA } from "./SectionCTA";
import { painPoints } from "../data/content";
export function PainPoints() {
  return <section className="bg-white px-5 py-16 md:px-8 md:py-24" data-id="element-250" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-5xl" data-id="element-251" data-mp="26yxtcue58i1y">
        <h2 className="text-3xl font-extrabold tracking-tight text-brand-900 md:text-[2.6rem]" data-id="element-252" data-mp="26y60hrbxkyfd">Does this sound familiar?</h2>
        <p className="mt-4 max-w-2xl text-lg text-muted" data-id="element-253" data-mp="2bv69aa060fa6">
          You recognize the symptoms, but organizing the entire case takes more effort than it should. Perhaps
          you've experienced situations like these:
        </p>

        <ol className="mt-10 grid gap-x-12 gap-y-8 md:grid-cols-2" data-id="element-254" data-mp="1o0d8vl6rcaxa">
          {painPoints.map((p, i) => <li key={p.title} className="flex gap-4 border-t border-brand-100 pt-6" data-id="element-255" data-mp="1szpuk2lw7bya" data-mpi={i}>
              <span className="text-3xl font-extrabold leading-none text-brand-300" data-id="element-256" data-mp="3idbgfx12otgx">{i + 1}</span>
              <div data-id="element-257" data-mp="3nd7hpoidy6ss">
                <h3 className="text-lg font-bold text-ink" data-id="element-258" data-mp="3nbcz4gul6qrv">{p.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-muted" data-id="element-259" data-mp="1z05770l8kmxi">{p.body}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-14 rounded-3xl bg-brand-900 p-7 text-white md:p-12" data-id="element-260" data-mp="1u1btp85y8vxc">
          <h3 className="text-2xl font-extrabold leading-snug md:text-3xl" data-id="element-261" data-mp="27rp2tdukugo9">
            The problem isn't that you need another endocrinology textbook.
          </h3>
          <p className="mt-4 text-lg leading-relaxed text-brand-100" data-id="element-262" data-mp="1g1at7ttljqie">
            You need a clinical workflow that helps translate established evidence and professional guidance into
            organized assessment steps. That's why the Perimenopause Clinical Decision Roadmap™ focuses on
            practical decision support.
          </p>
        </div>

        <SectionCTA label="Yes! Give me the complete roadmap" data-id="element-263" data-mp="1k5ilg0z9jold" />
      </div>
    </section>;
}